import { useRouter } from 'next/router';
import { MenuItem } from '@gogovan/entier-web-core/ext/mui/MenuItem';
import { Icon } from '@gogovan/entier-web-core/ext/mui/Icon';
import { InputAdornment } from '@gogovan/entier-web-core/ext/mui/InputAdornment';
import {
  CustomSelector,
  RegionLanSelectRow,
} from '@/modules/track-and-trace/region-language-selection/region-language-selection.styles';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';

const RegionLanguageSelection = () => {
  const router = useRouter();
  const { pathname, asPath, query, push } = router;
  const { i18n } = useTranslation('common');
  const timezoneMapping = {
    'Asia/Singapore': 'en-SG',
    'Asia/Hong_Kong': 'en-HK',
  };

  const languages = [
    {
      value: 'en-HK',
      label: 'Hong Kong (English)',
    },
    {
      value: 'zh-HK',
      label: '香港 (繁體中文)',
    },
    {
      value: 'en-SG',
      label: 'Singapore',
    },
    // {
    //   value: 'en-VI',
    //   label: 'Vietnam (English)',
    // },
  ];

  useEffect(() => {
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localLocale = timezoneMapping[localTimezone] || 'en-HK';
    const urlIdentifier = 'tms';
    if (pathname === '/' && !window.location.href.includes(router.locale)) {
      push(`${asPath}${urlIdentifier}`);
    } else if (!window.location.href.includes(router.locale)) {
      push({ pathname, query }, asPath, { locale: localLocale });
    } else if (!window.location.href.includes(urlIdentifier)) {
      push(`${asPath}${urlIdentifier}`);
    }
  }, []);

  const handleChangeLanguage = (event) => {
    push({ pathname, query }, asPath, { locale: event.target.value });
  };

  const languageMenuItems = (languageOptions) => {
    const options = [];
    languageOptions.forEach((l) => {
      options.push(
        <MenuItem value={l.value} key={l.value}>
          {l.label}
        </MenuItem>
      );
    });
    return options;
  };

  return (
    <RegionLanSelectRow>
      <CustomSelector
        value={i18n.language}
        variant='standard'
        disableUnderline
        onChange={handleChangeLanguage}
        startAdornment={
          <InputAdornment position='start'>
            <Icon>language</Icon>
          </InputAdornment>
        }
        inputProps={{
          IconComponent: () => null,
        }}
      >
        {languageMenuItems(languages)}
      </CustomSelector>
    </RegionLanSelectRow>
  );
};

export default RegionLanguageSelection;
